import React from "react";
import { CustomModal, DeleteModal } from "../../../shared";
import { CreateOrEditStockCategory } from "./CreateOrEditStockCategory";
import { StockCategoriesTable } from "./StockCategoriesTable";
import { useStockCategory } from "../hooks/useStockCategory";

export const StockCategories = () => {
  const {
    listQuery: { isLoading, data },
    deleteInfo,
    onDeleteAction,
    resetDeleteInfo,
    confirmDelete,
    onChange,
    onSubmit,
    handleClickOpen,
    handleClose,
    category,
    searchHandler,
    validator,
    onSelectItem,
    updateCategory,
    createCategory,
    CategoryValuesHandler,
    onDragEnd,
    onSubCategoryDragEnd,
    deleteCategory,
    isCreateVisible,
    isSubCategoryCreateVisible,
    isSubCategoryEditable,
    isSubCategoryDeletable,
    isEditable,
    isDeletable,
  } = useStockCategory({ categorylist: true });

  return (
    <>
      <StockCategoriesTable
        data={data}
        handleClickOpen={handleClickOpen}
        onSelectItem={onSelectItem}
        onDelete={onDeleteAction}
        searchHandler={searchHandler}
        category={category}
        isLoading={isLoading}
        onDragEnd={onDragEnd}
        onSubCategoryDragEnd={onSubCategoryDragEnd}
        isSubCategoryCreateVisible={isSubCategoryCreateVisible}
        isCreateVisible={isCreateVisible}
        isSubCategoryEditable={isSubCategoryEditable}
        isSubCategoryDeletable={isSubCategoryDeletable}
        isEditable={isEditable}
        isDeletable={isDeletable}
      />
      <CustomModal
        handleClose={() => handleClose(false)}
        open={category.isOpen}
        title={
          (category?.id ? "Edit " : "Create ") +
          (category.isSubItem ? "Sub Category" : "Category")
        }
        onSubmit={onSubmit}
        isEdit={category?.id}
        isDisableSubmit={
          category?.id > 0
            ? updateCategory?.isPending
            : createCategory?.isPending
        }
        content={
          <CreateOrEditStockCategory
            categoryOptions={data}
            isSubItem={category.isSubItem}
            validator={validator}
            state={category}
            isEdit={category?.id}
            onChange={onChange}
            CategoryValuesHandler={CategoryValuesHandler}
          />
        }
      />
      <DeleteModal
        open={deleteInfo.show}
        deleteCategory={deleteCategory}
        handleClose={() => resetDeleteInfo()}
        onConfirm={() => confirmDelete()}
      />
    </>
  );
};
